import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewIndex = () => import('./index')

Vue.use(Router)

const router =
  [
    {
      path: '/sa/parametrs',
      component: DefaultContainer,
      children: [
        {
          path: 'configurate',
          name: 'SA_ParametrsConfigurate',
          component: ViewIndex,
          beforeEnter: Permisos.IS_SUPERADMIN,
          meta: {
            title: 'Parámetros',
          }                    
        },
      ]
    },
  ]

export default router
